import { useSelector, shallowEqual } from 'react-redux';
import type { RootState } from '../store';

const identitySelector = ({ identity }: RootState) => {
  return {
    identity,
  };
};

export const useIdentity = () => {
  const { identity } = useSelector(identitySelector, shallowEqual);
  return {
    ...identity,
    isSignedIn: identity?.isSignedIn,
  };
};
